import parseISO from 'date-fns/parseISO'
import isWithinInterval from 'date-fns/isWithinInterval'
import isDate from 'date-fns/isDate'
import differenceInMinutes from 'date-fns/differenceInMinutes'
const isEmpty = data => {
  if (typeof data === 'number' || typeof data === 'boolean') {
    return false
  }
  if (typeof data === 'undefined' || data === null) {
    return true
  }
  if (typeof data.length !== 'undefined') {
    return data.length === 0
  }
  var count = 0
  for (var i in data) {
    // eslint-disable-next-line no-prototype-builtins
    if (data.hasOwnProperty(i)) {
      count++
    }
  }
  return count === 0
}

const isNotEmpty = data => {
  return !isEmpty(data)
}

/*!
 * Check if two objects or arrays are equal
 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Object|Array}  value  The first object or array to compare
 * @param  {Object|Array}  other  The second object or array to compare
 * @return {Boolean}              Returns true if they're equal
 */
const isEqual = function (value, other) {
  // Get the value type
  var type = Object.prototype.toString.call(value)

  // If the two objects are not the same type, return false
  if (type !== Object.prototype.toString.call(other)) return false

  // If items are not an object or array, return false
  if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false

  // Compare the length of the length of the two items
  var valueLen =
    type === '[object Array]' ? value.length : Object.keys(value).length
  var otherLen =
    type === '[object Array]' ? other.length : Object.keys(other).length
  if (valueLen !== otherLen) return false

  // Compare two items
  var compare = function (item1, item2) {
    // Get the object type
    var itemType = Object.prototype.toString.call(item1)

    // If an object or array, compare recursively
    if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
      if (!isEqual(item1, item2)) return false
    } else {
      // Otherwise, do a simple comparison
      // If the two items are not the same type, return false
      if (itemType !== Object.prototype.toString.call(item2)) return false

      // Else if it's a function, convert to a string and compare
      // Otherwise, just compare
      if (itemType === '[object Function]') {
        if (item1.toString() !== item2.toString()) return false
      } else {
        if (item1 !== item2) return false
      }
    }
  }

  // Compare properties
  if (type === '[object Array]') {
    for (var i = 0; i < valueLen; i++) {
      if (compare(value[i], other[i]) === false) return false
    }
  } else {
    for (var key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        if (compare(value[key], other[key]) === false) return false
      }
    }
  }

  // If nothing failed, return true
  return true
}

// Originally inspired by  David Walsh (https://davidwalsh.name/javascript-debounce-function)

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// `wait` milliseconds.
const debounce = (func, wait) => {
  let timeout

  // This is the function that is returned and will be executed many times
  // We spread (...args) to capture any number of parameters we want to pass
  return function executedFunction (...args) {
    // The callback function to be executed after
    // the debounce time has elapsed
    const later = () => {
      // null timeout to indicate the debounce ended
      timeout = null

      // Execute the callback
      func(...args)
    }
    // This will reset the waiting every function execution.
    // This is the step that prevents the function from
    // being executed because it will never reach the
    // inside of the previous setTimeout
    clearTimeout(timeout)

    // Restart the debounce waiting period.
    // setTimeout returns a truthy value (it differs in web vs Node)
    timeout = setTimeout(later, wait)
  }
}

/**
 * @description determine if an array contains one or more items from another array.
 * @param {array} haystack the array to search.
 * @param {array} arr the array providing items to check for in the haystack.
 * @return {boolean} true|false if haystack contains at least one item from arr.
 */
const findOne = function (haystack, arr) {
  return arr.some(function (v) {
    return haystack.indexOf(v) >= 0
  })
}

/**
 * Extracting a list of property values from an array of objects only of those objects with key:
 * @param {array} objects the array of objects
 * @param { string} key the object key to remove
 */
const pluck = (objects, key) => {
  return objects.filter(object => {
    return key in object
  })
    .map(function (object) {
      return object[key]
    })
}

/**
 *
 * @param htmlString
 * @returns {ChildNode}
 */
const createElementFromHTML = (htmlString) => {
  var div = document.createElement('div')
  div.innerHTML = htmlString.trim()

  // Change this to div.childNodes to support multiple top-level nodes.
  return div.firstChild
}

const schoolYearFromDate = (checkDate) => {
  console.log('utilities.schoolYearFromDate', checkDate)
  let dateToCheck = checkDate
  if (dateToCheck === null) {
    dateToCheck = new Date()
  } else if (!isDate(dateToCheck)) {
    dateToCheck = parseISO(dateToCheck)
  }
  console.log('utilities.schoolYearFromDate month', dateToCheck.getMonth(), dateToCheck.getFullYear())
  if (dateToCheck.getMonth() < 6) {
    return (dateToCheck.getFullYear() - 1)
  } else {
    return dateToCheck.getFullYear()
  }
}

const isDateBetween = (startDate, endDate, checkDate = null) => {
  let dateToCheck = checkDate
  if (dateToCheck === null) {
    dateToCheck = new Date()
  } else if (!isDate(dateToCheck)) {
    dateToCheck = parseISO(dateToCheck)
  }
  const start = isDate(startDate) ? startDate : parseISO(startDate)
  const end = isDate(endDate) ? endDate : parseISO(endDate)
  return isWithinInterval(dateToCheck, {
    start: start,
    end: end
  })
}

const isSameMinutes = (startTime, endTime) => {
  let start = startTime
  let end = endTime
  if (!isDate(startTime)) {
    start = parseISO(startTime)
  }
  if (!isDate(endTime)) {
    end = parseISO(endTime)
  }
  return differenceInMinutes(start, end) === 0
}
export {
  isEmpty, isNotEmpty, isEqual,
  isDateBetween, isSameMinutes, schoolYearFromDate,
  findOne, debounce, pluck, createElementFromHTML
}
